import React from "react";
import RosePie from "charts/RosePie";

const color = ["#7ff4f7", "#3f5fd2", "#489abb", "#bd40a4", "#5d65d8"];
const data = [
  { name: "20以下", value: 3.65 },
  { name: "20-29", value: 53.2 },
  { name: "30-39", value: 30.5 },
  { name: "40-49", value: 10.2 },
  { name: "50以上", value: 2.45 },
];

const Age: React.FC = () => {
  return <RosePie data={data} ring color={color} />;
};

export default Age;
